<script lang="ts">
	import Price from '$lib/components/Price.svelte';
	import { m } from '$lib/paraglide/messages.js';

	let {
		startingAt,
		variant,
		optionsPrice,
	}: { startingAt: boolean; variant: Variant; optionsPrice: number } = $props();
</script>

{#if variant.price}
	<div class="flex flex-col items-center md:flex-row md:items-baseline md:gap-2">
		{#if startingAt}
			<span class="-mb-1.5 text-sm whitespace-nowrap text-neutral-600 md:mb-0">
				{m.starting_at()}
			</span>
		{/if}

		<div class="flex items-baseline gap-1">
			<span
				class={variant.special_price !== null
					? 'text-sm line-through'
					: 'text-xl font-medium text-black md:text-2xl'}
			>
				<Price price={variant.price + optionsPrice} />
			</span>

			{#if variant.special_price}
				<span class="text-xl font-semibold whitespace-nowrap text-red-600 md:text-2xl">
					<Price price={variant.special_price + optionsPrice} />
				</span>

				{@const discountPercent = ((variant.price - variant.special_price) / variant.price) * 100}
				{#if discountPercent >= 5}
					<span class="self-center rounded-sm border-1 px-2 py-0.5 text-sm font-light text-red-600">
						-{discountPercent.toFixed(0)}%
					</span>
				{/if}
			{/if}
		</div>
	</div>
{/if}
